/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class AddTypeCar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  submit(e) {
    e.preventDefault()
  }

  addTypeCar() {
    var name = document.getElementById('name').value
    var description = document.getElementById('description').value
    var nameError = false
    var descriptionError = false
    var formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام نوع خودرو وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (description == '') {
      formError = true
      descriptionError = true
      message.error('یک توضیح مختصر برای خودرو وارد کنید')
    } else {
      if (!descriptionError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: name,
        description: description
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ADD_CAR}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('نوع خودروی جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/Cars')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Cars'}>لیست نوع اتومبیل ها</Link>
            </li>
            <li>ثبت نوع اتومبیل</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت نوع اتومبیل</p>
            </div>
            <div className="formComponent">
              <label>
                نام نوع خودرو <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                توضیحات <span className="requireFiled">*</span>
              </label>
              <textarea name="description" id="description" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addTypeCar.bind(this)}>
                ثبت نوع خودروی جدید
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddTypeCar
